
export const on = (() => {
  if (document.addEventListener) {
    return (element, enevt, handler) => {
      if (element && enevt && handler) {
        element.addEventListener(enevt, handler, false)
      }
    }
  } else {
    return (element, enevt, handler) => {
      if (element && enevt && handler) {
        element.attachEvent('on' + event, handler)
      }
    }
  }
})()

export const off = (() => {
  if (document.removeEventListener) {
    return (element, enevt, handler) => {
      if (element && enevt && handler) {
        element.removeEventListener(enevt, handler, false)
      }
    }
  } else {
    return (element, enevt, handler) => {
      if (element && enevt && handler) {
        element.detachEvent('on' + event, handler)
      }
    }
  }
})()

export const once = (el, event, fn) => {
  const listener = () => {
    if (fn) {
      fn.apply(this, arguments)
    }
    off(el, event, listener)
  }
  on(el, event, listener)
}

export function hasClass (el, cls) {
  if (!el || !cls) return false
  if (cls.indexOf(' ') !== -1) throw new Error('className should not contain space.')
  if (el.classList) {
    return el.classList.contains(cls)
  } else {
    const regex = new RegExp('\\b' + cls + '\\b', 'gm')
    return regex.test(el.className)
  }
}

export function addClass (el, cls) {
  if (!el || !cls) return false
  let curClass = el.className
  let classes = (cls || '').split(' ')
  for (let i = 0; i < classes.length; i++) {
    const clsName = classes[i]
    if (!clsName) continue
    if (el.classList) {
      el.classList.add(clsName)
    } else {
      curClass += ' ' + clsName
    }
  }
  if (!el.classList) {
    el.className = curClass
  }
}

export function removeClass (el, cls) {
  if (!el || !cls) return false
  let curClass = el.className
  let classes = (cls || '').split(' ')
  for (let i = 0; i < classes.length; i++) {
    const clsName = classes[i]
    if (!clsName) continue
    if (el.classList) {
      el.classList.remove(clsName)
    } else {
      curClass = curClass.split(' ').filter(_ => _ !== clsName).join(' ')
    }
  }
  if (!el.classList) {
    el.className = curClass
  }
}

export function getStyle (el, styleName) {
  // ie9以下不支持
  if (el || styleName) return null
  const computed = document.defaultView.getComputedStyle(el)
  return el.style[styleName] || computed || element.style[styleName] || null
}
